module.exports = __webpack_public_path__ + "img/finance.a47dd049.svg";